import _objectSpread from "/Users/ahmerafzal/Documents/Work/Brandripplr/v2/project/brandripplr/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/Users/ahmerafzal/Documents/Work/Brandripplr/v2/project/brandripplr/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/Users/ahmerafzal/Documents/Work/Brandripplr/v2/project/brandripplr/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/Users/ahmerafzal/Documents/Work/Brandripplr/v2/project/brandripplr/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.link.js";
import { store } from "@/stores/store";
import { NotificationService } from "@/services/notification.service";
export default {
  name: "HeaderNotifications",
  data: function data() {
    return {
      store: store,
      items: [],
      unread: 0,
      loading: false,
      unsubscribe: null
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$store;
      var uid;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this.refreshCount();
          case 1:
            uid = (_this$store = _this.store) === null || _this$store === void 0 || (_this$store = _this$store.currentUser) === null || _this$store === void 0 ? void 0 : _this$store.id;
            if (uid) {
              _this.unsubscribe = NotificationService.subscribe(uid, function (row) {
                var _this$$toast, _this$$toast$add;
                _this.unread += 1;
                _this.items = [row].concat(_toConsumableArray(_this.items)).slice(0, 30);
                (_this$$toast = _this.$toast) === null || _this$$toast === void 0 || (_this$$toast$add = _this$$toast.add) === null || _this$$toast$add === void 0 || _this$$toast$add.call(_this$$toast, {
                  severity: "info",
                  summary: row.title,
                  detail: row.body || "",
                  life: 6000
                });
              });
            }
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  beforeUnmount: function beforeUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    refreshCount: function refreshCount() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$NotificationSe, count;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return NotificationService.unreadCount();
            case 1:
              _yield$NotificationSe = _context2.v;
              count = _yield$NotificationSe.count;
              _this2.unread = count;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    opened: function opened() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$NotificationSe2, notifications;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.loading = true;
              _context3.n = 1;
              return NotificationService.list();
            case 1:
              _yield$NotificationSe2 = _context3.v;
              notifications = _yield$NotificationSe2.notifications;
              _this3.items = notifications;
              _this3.loading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    kindClass: function kindClass(n) {
      var _n$meta;
      var a = (_n$meta = n.meta) === null || _n$meta === void 0 ? void 0 : _n$meta.action;
      return a === "approve" ? "ok" : a === "reject" ? "bad" : "warn";
    },
    ago: function ago(iso) {
      var s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
      if (s < 60) return "just now";
      if (s < 3600) return Math.floor(s / 60) + " min ago";
      if (s < 86400) return Math.floor(s / 3600) + " h ago";
      if (s < 7 * 86400) return Math.floor(s / 86400) + " d ago";
      return new Date(iso).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short"
      });
    },
    open: function open(n) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var target;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!n.read_at) {
                n.read_at = new Date().toISOString();
                _this4.unread = Math.max(0, _this4.unread - 1);
                NotificationService.markRead(n.id);
              }
              if (!n.link) {
                _context4.n = 3;
                break;
              }
              // same route with a new query (tracker deep link) needs a replace to re-run mounted()
              target = n.link;
              if (!(_this4.$route.fullPath === target)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!(_this4.$route.path === target.split("?")[0])) {
                _context4.n = 2;
                break;
              }
              _context4.n = 2;
              return _this4.$router.replace({
                path: "/management"
              });
            case 2:
              _this4.$router.push(target);
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    markAll: function markAll() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return NotificationService.markAllRead();
            case 1:
              _this5.items = _this5.items.map(function (n) {
                return _objectSpread(_objectSpread({}, n), {}, {
                  read_at: n.read_at || new Date().toISOString()
                });
              });
              _this5.unread = 0;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};